import { t, Trans } from '@lingui/macro'
import { TextField } from '@mui/material'
import { Control, Controller } from 'react-hook-form'
import { RegionPicker } from './RegionPicker'

interface S3CommonFieldsProps {
    control: Control<any>
    isLoading?: boolean
    prefix: 'deliveryAwsInternal' | 'deliveryAwsExternal'
}

export const S3CommonFields = ({ control, isLoading = false, prefix }: S3CommonFieldsProps) => {
    return (
        <>
            <Controller
                control={control}
                // eslint-disable-next-line string-to-lingui/missing-lingui-transformation
                name={`${prefix}RootDirectory`}
                render={({ field: { value, onChange } }) => (
                    <TextField
                        // eslint-disable-next-line string-to-lingui/missing-lingui-transformation
                        id={`${prefix}RootDirectory`}
                        label={<Trans>Root Directory</Trans>}
                        disabled={isLoading}
                        value={value}
                        onChange={onChange}
                    />
                )}
            />
            <Controller
                control={control}
                // eslint-disable-next-line string-to-lingui/missing-lingui-transformation
                name={`${prefix}Region`}
                render={({ field: { value, onChange } }) => (
                    <RegionPicker value={value || ''} onChange={onChange} label={t`AWS Region`} required disabled={isLoading} />
                )}
            />
        </>
    )
}
